import api from './api';
import {
  ClubAddress as PubAddress,
  DartCloudTime,
  OpeningHour,
  ClubTrainingSchedule as WeekSchedule,
  ClubTeam as PubTeam,
  TeamLink,
  SocialMediaCollection,
  normalizeDetail,
} from './clubService';

export type { PubAddress, DartCloudTime, OpeningHour, WeekSchedule, PubTeam, TeamLink, SocialMediaCollection };

export interface Pub {
  _id?: string;
  id?: string;
  name?: string;
  slug?: string;
  description?: string | null;
  image?: string | null;
  images?: string[] | null;
  logo?: string | null;

  address?: PubAddress;

  email?: string | null;
  phone?: string | null;

  openingHours?: WeekSchedule | null;
  playingHours?: WeekSchedule | null;

  menuFiles?: string[] | null;

  steeldart?: boolean | null;
  edart?: boolean | null;
  flat?: boolean | null;
  rentable?: boolean | null;

  teams?: PubTeam[];

  series?: string[];
  tournaments?: string[];

  socialMediaCollection?: SocialMediaCollection | null;
  tags?: string[] | null;

  owner?: string | null;
  admins?: string[];
  createdBy?: string | null;
  createdAt?: number;
  updatedAt?: number | null;
  validUntil?: number;
  visible?: boolean;
  sponsored?: boolean;
  views?: number;
}

export interface PubDetailResponse {
  success: boolean;
  data: Pub | null;
}

class PubService {
  async getPubBySlug(slug: string): Promise<PubDetailResponse> {
    const res = await api.get(`/api/pubs/${encodeURIComponent(slug)}`);
    return normalizeDetail<Pub>(res.data);
  }

  async getPubById(id: string): Promise<PubDetailResponse> {
    const res = await api.get(`/api/pub/${encodeURIComponent(id)}`);
    return normalizeDetail<Pub>(res.data);
  }

  async createPub(payload: any): Promise<any> {
    const res = await api.post('/api/pubs/create', payload);
    return res.data;
  }

  async updatePub(payload: any): Promise<any> {
    const res = await api.post('/api/pubs/update', payload);
    return res.data;
  }

  async deletePub(id: string): Promise<any> {
    const res = await api.post('/api/pubs/delete', { id });
    return res.data;
  }

  async addImage(id: string, data: string): Promise<any> {
    const res = await api.post('/api/pubs/image/add', { id, data });
    return res.data;
  }

  async removeImage(id: string, image: string): Promise<any> {
    const res = await api.post('/api/pubs/image/remove', { id, image });
    return res.data;
  }

  buildFileUrl(fileId?: string | null): string | null {
    if (!fileId) return null;
    if (fileId.startsWith('http://') || fileId.startsWith('https://')) return fileId;
    const base = api.defaults.baseURL || '';
    return `${base}/api/file/${fileId}`;
  }

  formatAddress(address?: PubAddress | null): string {
    if (!address) return 'Adresse nicht hinterlegt';
    if (address.label && address.label.trim().length > 0) return address.label;
    const parts: string[] = [];
    if (address.street) parts.push(address.street);
    const cityLine = [address.postcode, address.city].filter(Boolean).join(' ');
    if (cityLine) parts.push(cityLine);
    if (address.country) parts.push(address.country);
    return parts.length ? parts.join(', ') : 'Adresse nicht hinterlegt';
  }
}

export default new PubService();
